import React, { memo } from "react";
import { useLabels } from "../../../hooks/useLabels";
import { useUserEvents } from "../../../hooks/useUserEvents";
import { Button } from "../../button";
import { EmptyState } from "../../empty-placeholder/empty-state";
import { labels } from "./labels";
import { useUserDateDialogActions, useUserDateDialogState } from "./use-user-date-dialog-state";
import { UserDateItem } from "./user-date-item";

import "./user-date-list.css";

export const UserDateList = memo(() => {
	const [[showAllText, hideAllText, emptyTitle, emptyText]] = useLabels([
		labels.showAll,
		labels.hideAll,
		labels.noEventsTitle,
		labels.noEventsText,
	]);

	const { isLoading: isAccountUserDatesLoading } = useUserEvents();

	const { sortedUserDates, userDates } = useUserDateDialogState();

	const { toggleAll } = useUserDateDialogActions();

	return (
		<div className="user-date-list">
			{!!userDates.size && (
				<div className="user-date-list__filter">
					<Button onClick={() => toggleAll(true)}>{showAllText}</Button>
					<Button onClick={() => toggleAll(false)}>{hideAllText}</Button>
				</div>
			)}

			{sortedUserDates.map(({ id, dateCode, value }) => (
				<UserDateItem key={id} dateCode={dateCode} id={id} value={value} />
			))}
			{!(!!userDates.size || isAccountUserDatesLoading) && (
				<EmptyState
					title={emptyTitle}
					subtitle={emptyText}
					className="user-date-list__placeholder"
					iconName="calendar"
				/>
			)}
		</div>
	);
});
UserDateList.displayName = "UserDateList";
